import { render } from "./NotificationVerifier.vue?vue&type=template&id=18bf43c8&scoped=true"
import script from "./NotificationVerifier.vue?vue&type=script&lang=js"
export * from "./NotificationVerifier.vue?vue&type=script&lang=js"

import "./NotificationVerifier.vue?vue&type=style&index=0&id=18bf43c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bf43c8"]])

export default __exports__